import { Foto } from './../model/foto';
import { Observable, BehaviorSubject, combineLatest } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Base } from './../model/base';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { AngularFireStorage } from 'angularfire2/storage';
import { Injectable } from '@angular/core';
import { HttpClient } from '../../../node_modules/@angular/common/http';

@Injectable()
export abstract class Service<E extends Base> {

  public static className = 'Service';

  private itemsCollection: AngularFirestoreCollection<E>;
  private itemDoc: AngularFirestoreDocument<E>;

  items$: Observable<E[]>;
  gotoPage$: BehaviorSubject<number | null>;
  pages: Map<number, any> = new Map();
  currentPage$ = 1;

  uploadPercent: Observable<number>;

  constructor(protected afs: AngularFirestore, private storage: AngularFireStorage, protected http: HttpClient) {
  }

  protected abstract getTable();
  protected getPageMax() {
    return 10;
  }

  public getItemsCollection() {
    if (this.itemsCollection == null) {
      this.itemsCollection = this.afs.collection<E>(this.getTable());
    }
    return this.itemsCollection;
  }

  public criaId() {
    return new Date().getTime() + '_' + Math.random();
  }

  ultimas(limit: number) {
    const ultimasCollection = this.afs.collection<E>(this.getTable(), ref => ref.orderBy('id', 'desc').limit(limit));
    return ultimasCollection.valueChanges();
  }

  getBasicQuery(ref: firebase.firestore.CollectionReference) {
    return ref.orderBy('id', 'desc').limit(this.getPageMax());
  }

  paginacao() {
    this.gotoPage$ = new BehaviorSubject(null);
    this.items$ = combineLatest(
      this.gotoPage$
    ).pipe(
      switchMap(([page]) =>
        this.afs.collection<E>(this.getTable(), ref => {
          let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref.orderBy('id', 'desc').limit(this.getPageMax());
          if (page && this.currentPage$ < page) {
            query = query.startAfter(this.pages[page - 1].lastId).endAt(null);
            this.currentPage$ = page;
          }
          if (page && this.currentPage$ > page) {
            query = query.startAt(this.pages[page].firstId).endAt(this.pages[page].lastId);
            this.currentPage$ = page;
          }
          return query;
        }).valueChanges().do(v => {
          if (v.length > 0) {
            this.pages[this.currentPage$] = { firstId: v[0].id, lastId: v[v.length - 1].id };
          }
        })
      )
    );
    return this.items$;
  }

  proximaPagina() {
    this.gotoPage$.next(this.currentPage$ + 1);
  }

  paginaAnterior() {
    if (this.currentPage$ !== 1) {
      this.gotoPage$.next(this.currentPage$ - 1);
    }
  }

  listar() {
    const ultimasCollection = this.afs.collection<E>(this.getTable(), ref => ref.orderBy('id', 'desc'));
    return ultimasCollection.valueChanges();
  }

  find(id) {
    this.itemDoc = this.afs.doc<E>(this.getTable() + '/' + id);
    return this.itemDoc.valueChanges();
  }

  addItem(item: E) {
    item.id = this.criaId();
    this.salvar(item);
  }

  salvar(item: E) {
    return this.getItemsCollection().doc(item.id.toString()).set(item);
  }

  upload(file) {
    const id = this.criaId();
    console.log('Uplod file - id: ' + id);
    const task = this.storage.upload(this.getTable() + '/' + id, file);
    this.uploadPercent = task.percentageChanges();
    return task.then(uploadFile => {
      return uploadFile.ref.getDownloadURL().then(url => {
        const foto: Foto = {
          id: id,
          url: url
        };
        return foto;
      });
    });
  }

  deleteFile(id) {
    const ref = this.storage.ref(this.getTable() + '/' + id);
    return ref.delete();
  }

  public delete(id) {
    const ref = this.find(id);
    return this.itemDoc.delete();
  }

}



// WEBPACK FOOTER //
// ./src/app/service/service.service.ts